export default __webpack_public_path__ + "img/x-24.774214f7.svg";